export const ErrorNotificationIcon: React.FC<{ width?: string; height?: string }> = ({ width, height }) => (
  <svg width={width ?? '32'} height={height ?? '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15" stroke="#D31111" strokeWidth="2" />
    <path
      d="M14.368 6.912H17.368L16.624 19.224H15.136L14.368 6.912ZM17.32 21.12V24H14.44V21.12H17.32Z"
      fill="#D31111"
    />
  </svg>
);
